import type { AvailableFilters } from "@/modules/jobAds/client/hooks/useJobAdsFilterNavigation"

import { useCallback } from "react"

import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { useTracking } from "@/modules/tracking/useTracking"

type CompanyJobOffersSearchTrackFunction = (query: AvailableFilters, totalSize?: number) => void

export const useCompanyJobOffersSearchTrack = (): CompanyJobOffersSearchTrackFunction => {
  const tracking = useTracking()
  const { dataCompany } = useCompanyFetch()
  const { dataCareerCenter } = useCareerCenterFetch()

  return useCallback(
    (query: AvailableFilters, totalSize = 0) => {
      return tracking?.track("company_job_offers_search", {
        company_id: dataCompany?.id || null,
        contracts: [query.contract].flatMap(singleInput => singleInput).filter(Boolean) as string[],
        keyword: query.q ? `${query.q}` : "",
        nb_results: totalSize,
        position_categories: [query.position_category_uuid]
          .flatMap(singleInput => singleInput)
          .filter(Boolean) as string[],
        with_keyword_only: Object.keys(query).length === 1 && query.q !== undefined,
        ...(dataCareerCenter?.intranet && { school_id: dataCareerCenter?.id }),
        service: "company",
      })
    },
    [tracking, dataCareerCenter?.id, dataCareerCenter?.intranet, dataCompany?.id]
  )
}
